export default __webpack_public_path__ + "static/media/React.47f23ffb.png";